import { defineStore } from 'pinia'

import type { MasteryMapStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useMasteryMapStore = defineStore('mastery-map', {
  state: (): MasteryMapStore => ({
    document: null,
    loading: false,
    list: [],
    listLoading: false,
  }),
  actions,
  getters,
})
